export default __webpack_public_path__ + "static/media/search-icon.ebca538b.svg";